import React from "react";
import LoginPanel from "../components/loginPanel";

function LoginPage() {
  return <LoginPanel />;
}

LoginPage.propTypes = {};
LoginPage.defaultProps = {};

export default LoginPage;
